
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M32.5 18h-17v12h17V18Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Rectangle 13",attrs:{"stroke":"#234652","d":"M19 21.5h10v5H19z"}}),_c('path',{staticClass:"i-Rectangle 918",attrs:{"d":"M39.734 11.585H12.73a4 4 0 0 0-4 4v9.274","stroke":"#234652"}}),_c('path',{staticClass:"i-Rectangle 37",attrs:{"d":"m34.624 16.873 5.35-5.35-5.35-5.352","stroke":"#234652"}}),_c('path',{staticClass:"i-Rectangle 919",attrs:{"d":"M8.971 36.484h27.004a4 4 0 0 0 4-4V23.21","stroke":"#234652"}}),_c('path',{staticClass:"i-Rectangle 920",attrs:{"d":"m14.081 31.196-5.35 5.351 5.35 5.351","stroke":"#234652"}})])
          )
        }
      }
    